export const ESBROWSE_URL = '/api/v2/deals/esbrowse/';
